export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const NAME_RE = /^[\p{L}\p{M}\.'\- ]{2,80}$/u;

export function isEmail(v: unknown): v is string {
  return typeof v === "string" && EMAIL_RE.test(v.trim());
}
export function isName(v: unknown): v is string {
  return typeof v === "string" && NAME_RE.test(v.trim());
}
export function isUuid(v: unknown): v is string {
  return typeof v === "string" &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v);
}
export function isOptionLetter(v: unknown): v is "A" | "B" | "C" | "D" {
  return v === "A" || v === "B" || v === "C" || v === "D";
}

export { validateRegistration } from "./registerValidation";
export type { RegisterValidation } from "./registerValidation";
